import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { DialogComponent } from '../components/common/dialog/dialog.component';
// import { ModalComponent } from '../components/modal/modal.component';

@Injectable()
export class ModalService {

  private modalViewSubject = new BehaviorSubject(null);
  public modalView = this.modalViewSubject.asObservable();

  constructor(
    public ngbModal: NgbModal,
  ) { }

  // public openModal(componentInstance:any, backdrop?: boolean | 'static', size?: 'sm' | 'lg', keyboard:boolean = false) {
  //   return this.openContent(ModalComponent, componentInstance, {
  //     size: size,
  //     backdrop: backdrop,
  //     keyboard: keyboard
  //   });
  // }

  public openContent(content:any, componentInstance:any, options?: NgbModalOptions): NgbModalRef {
    const modalRef = this.ngbModal.open(content, options);
    for (const o in componentInstance) {
      modalRef.componentInstance[o] = componentInstance[o];
    }
    return modalRef;
  }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/services/modal.service.ts